define([
    "csi/access/_base"
], function(csiAccess) {

	csiAccess.addViewRoles({
		
	});
});